'use client';

import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

interface UseFooterVisibilityInput {
  sectionRef: RefObject<HTMLElement | null>;
}

export function useFooterVisibility({
  sectionRef,
}: UseFooterVisibilityInput): boolean {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;
    if (!currentSection) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1,
        rootMargin: '0px',
      }
    );

    observer.observe(currentSection);

    const rect = currentSection.getBoundingClientRect();
    const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
    if (isInViewport) {
      setIsVisible(true);
    }

    return () => {
      observer.unobserve(currentSection);
    };
  }, [sectionRef]);

  return isVisible;
}
